import { Box, Typography } from "@mui/material";
import { colors, radii } from "../../../theme/designTokens";

// Replaces the `<Button sx={{pointerEvents:"none"}}>` fake-label-as-badge
// pattern previously used to render a static section tag.
export default function SectionLabelChip({ label, count }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        bgcolor: colors.primaryLight,
        color: colors.primary,
        borderRadius: radii.full,
        px: 1.5,
        py: 0.5,
      }}
    >
      <Typography component="span" sx={{ fontWeight: 700, fontSize: 13 }}>
        {label}
      </Typography>
      {count !== undefined && (
        <Box
          component="span"
          sx={{
            bgcolor: colors.primary,
            color: colors.white,
            borderRadius: radii.full,
            px: 0.75,
            fontSize: 11,
            fontWeight: 800,
          }}
        >
          {count}
        </Box>
      )}
    </Box>
  );
}
